export function SerialGiftDataModel () {
    this.agencyName = null;
    this.campaignId = null;
    this.campaignImg = null;
    this.campaignName = null;
    this.serial = null;
    this.redeemDate = null;
    this.barcode = null;
    this.expireIn = null;
    this.agencyId = null;
    this.aiaStatus = null;

    this.setDataFromAPI = function (data) {
        if (!data) return;

        // รองรับ payload ที่ถูกห่อมาใน Data
        var payload = data.Data || data.data || data;

        this.agencyName = payload.agency_name || payload.agencyName || payload.AgencyName || null;
        this.agencyId = payload.agency_id || payload.agencyId || payload.AgencyId || null;
        this.aiaStatus = payload.aia_status || payload.aiaStatus || payload.AiaStatus || null;

        this.barcode = payload.barcode || payload.Barcode || null;
        this.campaignName = payload.campaign_name || payload.campaignName || payload.CampaignName || null;
        this.expireIn = payload.expirein || payload.expire_in || payload.expireIn || payload.ExpireIn || null;
        this.serial = payload.serial || payload.Serial || null;
        this.redeemDate = payload.redeem_date || payload.redeemDate || payload.RedeemDate || null;

        var campaignImages = payload.campaign_image || payload.campaignImage || payload.CampaignImage || [];
        if (campaignImages.length > 0) {
            var campaignInfo = campaignImages[0];
            this.campaignId =
                campaignInfo.CampaignID ||
                campaignInfo.campaign_id ||
                campaignInfo.campaignId ||
                null;

            this.campaignImg =
                campaignInfo.FullImageUrl ||
                campaignInfo.full_image_url ||
                campaignInfo.fullImageUrl ||
                campaignInfo.ImageUrl ||
                campaignInfo.image_url ||
                campaignInfo.imageUrl ||
                null;
        } else {
            this.campaignId = null;
            this.campaignImg = null;
        }
    };
}